module.exports = __webpack_public_path__ + "static/img/glsmall03.d13cea1b.jpg";